import React from "react";
import styled from "styled-components";
import { Colors } from "../../ColorConstants";
import { Text } from "../../TextConstants";
import Button from "../Buttons";
import { useNavigate } from "react-router-dom";
import PromoApplied from "./PromoApplied";

const AddPromoCode = ({
  value,
  onChange,
  onApply,
  cart,
  userType,
  onContinueShopping,
  spinpromo,
  hasPromo,
  onRemove,
}) => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (value === "") {
    } else {
      onApply();
    }
  };
  const handleLoginSignUp = () => {
    navigate("/auth/login");
    localStorage.setItem("cartId", cart._id);
    localStorage.setItem("shouldContinue", "accept");
  };
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "flex-end",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <PromoCodeContainer>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <AddPromoTitle>{Text.addPromoCode}</AddPromoTitle>
          {/* {userType == "guest" ? (
            <GuestPromoLabel>
              <span onClick={() => handleLoginSignUp()}>Login or SignUp</span>{" "}
              to Access Promocode and Discounts!
            </GuestPromoLabel>
          ) : ( */}
          <AddPromoSubTitle>{Text.enterPromoCode}</AddPromoSubTitle>
          {/*  )} */}
        </div>
        <div>
          {value && cart?.promo && hasPromo ? (
            <PromoApplied cart={cart} onRemove={onRemove} />
          ) : (
            <ApplyPromoContainer>
              <TextInput
                value={value}
                placeholder="Enter Your Promo"
                onChange={onChange}
                disabled={spinpromo}
              ></TextInput>
              <PromoButtonContainer disabled={value == ""}>
                <Button
                  fontSize="0.9rem"
                  padding="12px 20px;"
                  label={Text.applyCoupon}
                  width="100%"
                  disabled={value == ""}
                  borderRadius="0 0.5rem 0.5rem 0"
                  variant="filled"
                  onClick={handleClick}
                />
              </PromoButtonContainer>

              {/* <ApplyPromoBtn onClick={handleClick} entered={value !== ""}>
          <ApplyPromoText>{Text.applyCoupon}</ApplyPromoText>
        </ApplyPromoBtn> */}
            </ApplyPromoContainer>
          )}
          {cart?.discountAmount > 0 && (
            <CouponSubTitle>Promo applied successfully</CouponSubTitle>
          )}
          {/* <AddPromoSubTitle>{Text.enterPromoCodeNote}</AddPromoSubTitle> */}
          {/* <ContinueButton onClick={onContinueShopping}>
        <ButtonTitle>{Text.continueShopping}</ButtonTitle>
      </ContinueButton> */}
        </div>
      </PromoCodeContainer>
      <PromoAppContainer>
        <AddPromoSubTitle>
          For more offers Download AL Maha Mobile App
        </AddPromoSubTitle>
      </PromoAppContainer>
    </div>
  );
};

const GuestPromoLabel = styled.div`
  margin-top: 0.5rem;
  // text-align: center;
  // padding: 0 2rem;
  font-size: 0.9rem;
  > span {
    color: ${Colors.aqua};
  }
`;

const PromoAppContainer = styled.div`
  text-align: right;
  width: 1024px;
  @media only screen and (max-width: 1024px) {
    width: 100%;
    padding: "0 1rem";
  }
  @media only screen and (max-width: 576px) {
    display: none;
  }
`;
const PromoCodeContainer = styled.div`
  background: #f6f6f6;
  padding: 1rem;
  flex-direction: row;
  width: 1024px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media only screen and (max-width: 1024px) {
    align-items: center;
    margin-bottom: 1rem;
    width: 100%;
  }
  @media only screen and (max-width: 576px) {
    display: none;
  }
`;
const AddPromoTitle = styled.span`
  color: ${Colors.arsenic};
  font-size: 1rem;
  font-weight: 900;
`;
const AddPromoSubTitle = styled(AddPromoTitle)`
  color: ${Colors.approxGrey};
  font-size: 0.9rem;
  font-weight: 400;
  margin-top: 0.5rem;
`;

const CouponSubTitle = styled(AddPromoTitle)`
  color: ${Colors.aqua};
  font-size: 0.9rem;
  font-weight: 400;
  margin-top: 1rem;
`;
const ApplyPromoContainer = styled.div`
  height: 2rem;
  border-radius: 12px;
  // border: 0.5px solid ${Colors.rainbowGrey};
  background: ${Colors.white};
  display: flex;
  // margin-top: 2rem;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "default")};
`;
const PromoButtonContainer = styled.div`
  width: 70%;
  border: ${(props) =>
    props.disabled ? "none" : `0.5px solid ${Colors.rainbowGrey}`};
  border-radius: 0 0.5rem 0.5rem 0;
  display: flex;
`;
const TextInput = styled.input`
  width: 70%;
  height: 100%;
  border-radius: 12px 0px 0px 12px;
  border: 0.5px solid ${Colors.rainbowGrey};
  box-sizing: border-box;
  outline: none;
  padding-left: 1rem;
  &:disabled {
    opacity: 0.4;
  }
`;
const ApplyPromoBtn = styled.div`
  width: 60%;
  height: 100%;
  border-radius: 0px 12px 12px 0px;
  box-sizing: border-box;
  background: ${(props) => (props.entered ? Colors.aqua : "grey")};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
const ApplyPromoText = styled.span`
  color: ${Colors.white};
  font-size: 1rem;
  font-weight: 700;
`;
const ContinueButton = styled.button`
  background: ${Colors.white};
  outline: none;
  display: flex;
  padding: 12px 20px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid ${Colors.rainbowGrey};
  margin-top: 2rem;
  width: 65%;
  cursor: pointer;
`;
const ButtonTitle = styled.span`
  font-size: 1rem;
  font-weight: 900;
  text-align: center;
  color: ${Colors.arsenic};
`;

export default AddPromoCode;
